import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { breakpoints, spacing } from '@naf/theme';

export const ContentContainer = styled.div<{ $isGuidePage?: boolean }>`
  ${({ $isGuidePage }) =>
    $isGuidePage
      ? ''
      : css`
          margin-bottom: ${spacing.space120};
        `}

  min-height: calc(100vh - 480px);
  padding-top: ${spacing.space160};

  @media (max-width: ${breakpoints.l}) {
    padding-top: ${spacing.space120};
  }
  @media (max-width: ${breakpoints.m}) {
    padding-top: ${spacing.space80};
  }
`;

export const Wrapper = styled.div`
  position: relative;
`;

export const StyledSkipLink = styled.a`
  position: absolute;
  top: -40px;
  left: 0;
  background: white;
  color: black;
  padding: 8px 16px;
  z-index: 1000;
  border-radius: 4px;
  transition: top 0.2s ease;
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  overflow: hidden;

  &:focus {
    top: 10px;
    clip: auto;
    width: auto;
    height: auto;
    overflow: visible;
  }
`;

export const MAX_WIDTH = '1216px';
export const GUIDE_MAX_WIDTH = '1920px';
export const MEMBER_BENEFIT_MAX_WIDTH = '1400px';

export const Content = styled.div<{ $isGuidePage?: boolean; $isMemberBenefitPage?: boolean }>`
  box-sizing: border-box;
  max-width: ${({ $isGuidePage, $isMemberBenefitPage }) => {
    if ($isMemberBenefitPage) return MEMBER_BENEFIT_MAX_WIDTH;
    if ($isGuidePage) return GUIDE_MAX_WIDTH;
    return MAX_WIDTH;
  }};
  margin: auto;
  padding: 0 ${({ $isGuidePage, $isMemberBenefitPage }) => ($isGuidePage || $isMemberBenefitPage ? 0 : spacing.space48)};
  flex-direction: column;

  @media (max-width: ${breakpoints.l}) {
    padding: 0 ${({ $isMemberBenefitPage }) => ($isMemberBenefitPage ? 0 : spacing.space24)};
  }
`;
